<ion-grid class="ion-padding">
  <ion-row *ngIf="informations.evaluationDetailItemAdditionalAttributes">
    <ion-col size="6" *ngFor="let attribute of informations?.evaluationDetailItemAdditionalAttributes">
      <h4 regular class="text-primary-dark-50 ion-no-margin">{{ attribute.name }}</h4>
      <h4 regular class="text-primary-dark ion-no-margin"> {{ attribute.value }} </h4>
    </ion-col>
    <ion-col size="12">
      <h4 regular class="text-primary-dark-50 ion-no-margin">{{ 'COMPONENTS.THE_AMOUNT' | translate }}</h4>
      <h4 regular class="text-primary-dark ion-no-margin">
        {{ informations.evaluationDetailItemQuantity ? informations.evaluationDetailItemQuantity : '1' }}
      </h4>
    </ion-col>
    <ion-col size="12">
      <h4 regular class="text-primary-dark-50 ion-no-margin">{{ 'COMPONENTS.STATE' | translate }}</h4>
      <h4 regular class="text-primary-dark ion-no-margin">
        <div [innerHTML]="informations.evaluationDetailItemConservationState"></div>
      </h4>
    </ion-col>
  </ion-row>
</ion-grid>

<div class="divider-dark"></div>

<ion-grid class="ion-padding" *ngIf="informations.evaluationDetailItemMaintenanceRequested">
  <ion-row>
    <ion-col size="12">
      <h3 class="text-danger" style="margin: 4px 0">{{ 'COMPONENTS.MAINTENANCE' | translate }}</h3>
    </ion-col>

    <ion-col size="6">
      <h4 regular class="text-primary-dark-50 ion-no-margin">{{ 'COMPONENTS.PRIORITY' | translate }}</h4>
      <h4 regular class="text-primary-dark ion-no-margin">
        {{ informations.maintenancePriorityType.maintenacePriorityTypeDescription | translate }}
      </h4>
    </ion-col>

    <ion-col size="6">
      <h4 regular class="text-primary-dark-50 ion-no-margin">{{ 'COMPONENTS.RESPONSIBLE' | translate }}</h4>
      <h4 regular class="text-primary-dark ion-no-margin">
        {{ informations.evaluationDetailItemMaintenanceResponsible }}
      </h4>
    </ion-col>

    <ion-col size="6">
      <h4 regular class="text-primary-dark-50 ion-no-margin">{{ 'COMPONENTS.DATE' | translate }}</h4>
      <h4 regular class="text-primary-dark ion-no-margin">
        {{ informations.evaluationDetailItemMaintenanceDate | date }}
      </h4>
    </ion-col>

    <ion-col size="6">
      <h4 regular class="text-primary-dark-50 ion-no-margin">{{ 'COMPONENTS.COST' | translate }}</h4>
      <h4 regular class="text-primary-dark ion-no-margin">
        {{ informations.evaluationDetailItemMaintenanceCostInCents / 100 | currency: 'BRL' }}
      </h4>
    </ion-col>
  </ion-row>
</ion-grid>

<div class="divider-dark"></div>

<ion-grid class="ion-padding">
  <ion-row *ngIf="informations?.evaluationDetailsItemsPhotos?.length > 0; else NoPhotos">
    <ion-col size="12">
      <h4 regular class="text-primary-dark-50 ion-no-margin">{{ 'COMPONENTS.PHOTOS' | translate }}</h4>
      <app-photo-gallery
        [canLoad]="false"
        [showButton]="false"
        [canRemove]="false"
        [styleInput]="{ 'padding-left': 0 }"
        [photoArray]="informations?.evaluationDetailsItemsPhotos"
        [componentId]="informations.evaluationSurveyElementItemId"
      ></app-photo-gallery>
    </ion-col>
  </ion-row>
</ion-grid>
<div class="divider"></div>

<ng-template #NoPhotos>
  <h4 regular class="text-primary-dark-50 ion-text-center ion-no-margin">{{
    'COMPONENTS.THERE_ARE_NO_PHOTOS' | translate
  }}</h4>
</ng-template>
